import { IconProps } from "../../../types/style";

const IdentityCheck = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 13 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.2928 5.37003L10.6128 4.58003C10.4828 4.43003 10.3778 4.15003 10.3778 3.95003V3.10003C10.3778 2.57003 9.94282 2.13503 9.41282 2.13503H8.56282C8.36782 2.13503 8.08282 2.03003 7.93282 1.90003L7.14282 1.22003C6.79782 0.925029 6.23282 0.925029 5.88282 1.22003L5.09782 1.90503C4.94782 2.03003 4.66282 2.13503 4.46782 2.13503H3.60282C3.07282 2.13503 2.63782 2.57003 2.63782 3.10003V3.95503C2.63782 4.15003 2.53282 4.43003 2.40782 4.58003L1.73282 5.37503C1.44282 5.72003 1.44282 6.28003 1.73282 6.62503L2.40782 7.42003C2.53282 7.57003 2.63782 7.85003 2.63782 8.04503V8.90003C2.63782 9.43003 3.07282 9.86503 3.60282 9.86503H4.46782C4.66282 9.86503 4.94782 9.97003 5.09782 10.1L5.88782 10.78C6.23282 11.075 6.79782 11.075 7.14782 10.78L7.93782 10.1C8.08782 9.97003 8.36782 9.86503 8.56782 9.86503H9.41782C9.94782 9.86503 10.3828 9.43003 10.3828 8.90003V8.05003C10.3828 7.85503 10.4878 7.57003 10.6178 7.42003L11.2978 6.63003C11.5878 6.28503 11.5878 5.71503 11.2928 5.37003ZM8.59282 5.05503L6.17782 7.47003C6.10782 7.54003 6.01282 7.58003 5.91282 7.58003C5.81282 7.58003 5.71782 7.54003 5.64782 7.47003L4.43782 6.26003C4.29282 6.11503 4.29282 5.87503 4.43782 5.73003C4.58282 5.58503 4.82282 5.58503 4.96782 5.73003L5.91282 6.67503L8.06282 4.52503C8.20782 4.38003 8.44782 4.38003 8.59282 4.52503C8.73782 4.67003 8.73782 4.91003 8.59282 5.05503Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default IdentityCheck;
